import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import classNames from "classnames";
import type { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import { AppInput } from "../../../../shared/components/AppInput";
import { EditIcon } from "../../../../shared/icons/EditIcon";
import { AppPopover } from "../../../AppPopover";
import { usePopover } from "../../../hooks/use-popover";
import styles from "../styles.module.css";

interface Props extends IconButtonProps {
  name: string;
  onEditName: () => void;
  handleNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onCancel: () => void;
  isDisabled?: boolean;
}

export const ChangeNameVersionAction: FC<Props> = ({
  name,
  onEditName,
  handleNameChange,
  isDisabled,
  onCancel,
  ...props
}) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        className={styles["action-button"]}
        onClick={handleOpenPopover}
        disabled={isDisabled}
        {...props}
      >
        <EditIcon
          className={classNames({
            [styles["disabled"]]: isDisabled,
          })}
        />
      </IconButton>
      <AppPopover
        anchorEl={anchorPopoverEl}
        handleClose={() => {
          onCancel();
          handleClosePopover();
        }}
        onOk={() => {
          onEditName();
          handleClosePopover();
        }}
        open={openPopover}
      >
        <AppInput
          value={name}
          placeholder={t("versioning.change_name_popover_placeholder")}
          onChange={handleNameChange}
        />
      </AppPopover>
    </>
  );
};
